import { Service } from "./index";
/**
 * [商户后台]获取秒杀商品表格数据列表
 * @export
 * @param {*} data
 * @return {*}
 */
export function getSeckillGoodsTableList(data) {
    return Service({
        url: "/amall_goods/seckill/manage/getShopSeckillGoodsManageList",
        method: "get",
        params: data
    });
}

/**
 * [商户后台]获取秒杀商品弹窗列表
 * @export
 * @param {*} data
 * @return {*}
 */
export function getSeckillGoodsList(data) {
    return Service({
        url: "/amall_goods/seckill/manage/getSeckillGoodsList",
        method: "get",
        params: data
    });
}

/**
 * [商户后台]获取秒杀商品详情
 * @export
 * @param {*} data
 * @return {*}
 */
export function getSeckillGoodsDetail(data) {
    return Service({
        url: "/amall_goods/seckill/manage/getSeckillDetail",
        method: "get",
        params: data
    });
}

/**
 * [商户后台]添加秒杀商品
 * @export
 * @param {*} data
 * @return {*}
 */
export function addSeckillGoods(data) {
    return Service({
        url: "/amall_goods/seckill/manage/addSeckillGoods",
        headers: {
            "Content-Type": "application/x-www-form-urlencoded;charset=utf-8"
        },
        method: "post",
        data: data
    });
}

/**
 * [商户后台]编辑秒杀商品
 * @export
 * @param {*} data
 * @return {*}
 */
export function editSeckillGoods(data) {
    return Service({
        url: "/amall_goods/seckill/manage/updateSeckillGoods",
        headers: {
            "Content-Type": "application/x-www-form-urlencoded;charset=utf-8"
        },
        method: "post",
        data: data
    });
}

/**
 * [商户后台]取消秒杀商品
 * @export
 * @param {*} data
 * @return {*}
 */
export function cancelSeckill(data) {
    return Service({
        url: "/amall_goods/seckill/manage/cancelSeckill",
        headers: {
            "Content-Type": "application/x-www-form-urlencoded;charset=utf-8"
        },
        method: "post",
        data: data
    });
}

/**
 * [商户后台]删除秒杀商品
 * @export
 * @param {*} data
 * @return {*}
 */
export function deleteSeckill(data) {
    return Service({
        url: "/amall_goods/seckill/manage/deleteSeckillGoods",
        headers: {
            "Content-Type": "application/x-www-form-urlencoded;charset=utf-8"
        },
        method: "post",
        data: data
    });
}


/**
 * [商户后台] [出价明细] 条件搜索出价明细记录
 * @export
 * @param {*} data
 * @return {*}
 */
export function getOfferDetailsList(data) {
    return Service({
        url: "/amall_user/user/offer/findOfferList",
        method: "post",
        data: data
    });
}


/**
 * [商户后台] [出价管理] 条件搜索商品
 * @export
 * @param {*} data
 * @return {*}
 */
export function getPriceList(data) {
    return Service({
        url: "/amall_user/user/offer/findGoodsOffer",
        method: "post",
        data: data
    });
}

/**
 * [商户后台] [出价管理] 新增商品出价最低价
 * @export
 * @param {*} data
 * @return {*}
 */
export function addPriceList(data) {
    return Service({
        url: "/amall_user/user/offer/addGoodsMinimumOffer",
        method: "post",
        data: data
    });
}

/**
 * [商户后台] [出价管理] 删除商品出价最低价
 * @export
 * @param {*} data
 * @return {*}
 */
export function deletePriceList(data) {
    return Service({
        url: "/amall_user/user/offer/delectGoodsMinimumOffer",
        headers: {
            "Content-Type": "application/x-www-form-urlencoded;charset=utf-8"
        },
        method: "post",
        data: data
    });
}


/**
 * [商户后台] [代理人管理] 添加代理分销价格
 * @export
 * @param {*} data
 * @return {*}
 */
export function addProxyDistributionPrice(data) {
    return Service({
        url: "/amall_goods/proxy/manage/addProxyDistributionPrice",
        method: "post",
        data: data
    });
}



/**
 * [商户后台] [代理人管理] 编辑代理分销价格
 * @export
 * @param {*} data
 * @return {*}
 */
 export function updateProxyDistributionPrice(data) {
    return Service({
        url: "/amall_goods/proxy/manage/updateProxyDistributionPrice",
        method: "post",
        data: data
    });
}


/**
 * [商户后台] [代理人管理] 获取代理商品列表
 * @export
 * @param {*} data
 * @return {*}
 */
export function getProxyGoodsList(data) {
    return Service({
        url: "/amall_goods/proxy/manage/getProxyGoodsList",
        method: "get",
        params: data
    });
}


/**
 * [商户后台]  [创建商户内部分销团队] 商户后台新增营销人员账号以及商户内部团队
 * @export
 * @param {*} data
 * @return {*}
 */
export function addShopPrivateMarketingTeam(data) {
    return Service({
        url: "/amall_user/marketing/addShopPrivateMarketingTeam",
        method: "post",
        data: data
    });
}


/**
 * [商户后台] [代理人管理]获取商品代理人列表
 * @export
 * @param {*} data
 * @return {*}
 */
export function getGoodsProxyList(data) {
    return Service({
        url: "/amall_goods/proxy/manage/getGoodsProxyList",
        method: "get",
        params: data
    });
}

/**
 * [商户后台]  根据营销员手机号查询该营销人员加入了那些营销团队
 * @export
 * @param {*} data
 * @return {*}
 */
export function findMarketingTeamByMarketingMoblie(data) {
    return Service({
        url: "/amall_user/marketing/findMarketingTeamByMarketingMoblie",
        headers: {
            "Content-Type": "application/x-www-form-urlencoded;charset=utf-8"
        },
        method: "post",
        data: data
    });
}


/**
 * [商户后台]  [商户代理人管理] 查询当前商户下的营销团队/内部分销账号,shopId 有值则查询该商户的
 * @export
 * @param {*} data
 * @return {*}
 */
export function findMarketingTeamByShopId(data) {
    return Service({
        url: "/amall_user/marketing/findMarketingTeamByShopId",
        method: "post",
        data: data
    });
}



/**
 * [商户后台] [代理人管理]获取规格代理分销价格列表
 * @export
 * @param {*} data
 * @return {*}
 */
export function getSpecProxyDistributionPriceList(data) {
    return Service({
        url: "/amall_goods/proxy/manage/getSpecProxyDistributionPriceList",
        method: "get",
        params: data
    });
}



/**
 * [商户后台]  [代理人管理]添加商品代理人
 * @export
 * @param {*} data
 * @return {*}
 */
export function addGoodsProxy(data) {
    return Service({
        url: "/amall_goods//proxy/manage/addGoodsProxy",
        headers: {
            "Content-Type": "application/x-www-form-urlencoded;charset=utf-8"
        },
        method: "post",
        data: data
    });
}


/**
 * [商户后台]  [代理人管理]编辑商品代理人
 * @export
 * @param {*} data
 * @return {*}
 */
 export function updateGoodsProxy(data) {
    return Service({
        url: "/amall_goods//proxy/manage/updateGoodsProxy",
        headers: {
            "Content-Type": "application/x-www-form-urlencoded;charset=utf-8"
        },
        method: "post",
        data: data
    });
}


/**
 * [商户后台][代理人管理]删除商品代理人
 * @export
 * @param {*} data
 * @return {*}
 */
 export function deleteGoodsProxy(data) {
    return Service({
        url: "/amall_goods/proxy/manage/deleteGoodsProxy",
        headers: {
            "Content-Type": "application/x-www-form-urlencoded;charset=utf-8"
        },
        method: "post",
        data: data
    });
}



/**
 * [商户后台][代理人管理]删除代理商品
 * @export
 * @param {*} data
 * @return {*}
 */
 export function deleteProxyGoods(data) {
    return Service({
        url: "/amall_goods/proxy/manage/deleteProxyGoods",
        headers: {
            "Content-Type": "application/x-www-form-urlencoded;charset=utf-8"
        },
        method: "post",
        data: data
    });
}



/**
 * [商户后台] [代理人管理]判断分销价格是否绑定代理人
 * @export
 * @param {*} data
 * @return {*}
 */
 export function judgeDistributionPriceIfBind(data) {
    return Service({
        url: "/amall_goods/proxy/manage/judgeDistributionPriceIfBind",
        method: "get",
        params: data
    });
}


// WEBPACK FOOTER //
// ./src/service/activity.js